export default __webpack_public_path__ + "static/media/iphone-12-mini--white.80e2fbfe.png";